module.exports = __webpack_public_path__ + "static/media/iconoFlechaAbajoAzul.911c06cd.svg";